<div class="header-container">
  <h3>Factoring Companies</h3>
  <div class="header-container-actions">
    <button matButton="elevated" class="charcoal-button" (click)="addEditFactoringCompany()">
      ADD FACTORING COMPANY
    </button>
    <mat-divider class="header-container-actions-divider" [vertical]="true"></mat-divider>
    <button matIconButton (click)="factoringCompaniesExpanded = !factoringCompaniesExpanded">
      <mat-icon>{{ factoringCompaniesExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </div>
</div>
<mat-divider></mat-divider>
<div [class.hidden]="!factoringCompaniesExpanded" class="factoring-section">
  <table
    #factoringCompaniesSort="matSort"
    (matSortChange)="activeFactoringCompaniesColumn = $event.active"
    [dataSource]="factoringCompaniesDataSource"
    class="table-style"
    mat-table
    matSort
    matSortActive="companyName"
    matSortDirection="asc"
    matSortDisableClear>
    <ng-container matColumnDef="companyName">
      <th
        *matHeaderCellDef
        [class.active]="activeFactoringCompaniesColumn === 'companyName'"
        mat-header-cell
        mat-sort-header>
        Factoring Company
      </th>
      <td class="body-1" *matCellDef="let factoringCompany" mat-cell>{{ factoringCompany.companyName }}</td>
    </ng-container>
    <ng-container matColumnDef="abn">
      <th *matHeaderCellDef [class.active]="activeFactoringCompaniesColumn === 'abn'" mat-header-cell mat-sort-header>
        ABN
      </th>
      <td class="body-1" *matCellDef="let factoringCompany" mat-cell>{{ factoringCompany.abn }}</td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th *matHeaderCellDef [class.active]="activeFactoringCompaniesColumn === 'email'" mat-header-cell mat-sort-header>
        Email
      </th>
      <td class="body-1" *matCellDef="let factoringCompany" mat-cell>{{ factoringCompany.email }}</td>
    </ng-container>
    <ng-container matColumnDef="phone">
      <th *matHeaderCellDef [class.active]="activeFactoringCompaniesColumn === 'phone'" mat-header-cell mat-sort-header>
        Contact
      </th>
      <td class="body-1" *matCellDef="let factoringCompany" mat-cell>{{ factoringCompany.phone }}</td>
    </ng-container>
    <ng-container matColumnDef="addressLine1">
      <th
        *matHeaderCellDef
        [class.active]="activeFactoringCompaniesColumn === 'addressLine1'"
        mat-header-cell
        mat-sort-header>
        Address
      </th>
      <td class="body-1" *matCellDef="let factoringCompany" mat-cell>
        <div>
          {{ factoringCompany.addressLine1 && factoringCompany.addressLine1 + ',' }}
          {{ factoringCompany.addressLine2 && factoringCompany.addressLine2 + ',' }}
          {{ factoringCompany.suburb && factoringCompany.suburb + ',' }}
        </div>
        <div>
          {{
            factoringCompany.country === 'Australia'
              ? factoringCompany.state && factoringCompany.state + ','
              : factoringCompany.city && factoringCompany.city + ','
          }}
          {{ factoringCompany.postCode && factoringCompany.postCode + ',' }} {{ factoringCompany.country }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="deleteCompany">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let factoringCompany" class="primary-icon" mat-cell>
        <button matIconButton (click)="$event.stopPropagation(); confirmDeleteFactoringCompany(factoringCompany.id)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr *matHeaderRowDef="factoringCompaniesColumnHeaders" mat-header-row></tr>
    <tr
      (click)="addEditFactoringCompany(row)"
      *matRowDef="let row; columns: factoringCompaniesColumnHeaders"
      mat-row></tr>
  </table>
  @if (!factoringCompaniesList?.length) {
    <div>
      <div class="no-results">No factoring companies</div>
    </div>
  }
</div>
